import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Row, Col, Table } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Search from "../commoncomponents/Search";
import ShowEntries from "../commoncomponents/ShowEntries";
import { encodeQueryData } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";


class CreateDevice extends Component {

  constructor(props) {
    super(props);

    this.state = {
      customerList: [],
      statusList: [],
      assetsList: [],
      roles: [],
      customerId: "default",
      imei: "",
      name: "",
      description: "",
      sim: "",
      type: "1",
      tag: "",
      networkType: "",
      firmware: "",
      assetId: "",
      assetName: "",
      status: "Active",
      customerID_error: false,
      name_error: false,
      imei_error: false,
      assetsPageCount: 0,
      //states for showing entries and total entries in page on Assets
      totalEntryA: 0,
      entryStartA: "0",
      entryEndA: "0",
      totalFilterA: false,
      totalEntryFilterA: "0",
      filterMessageA: false,
    };

    this.assetSearchText = "";
    this.assetPageKey = "1";
    this.assetPageSize = "10";

    this.formSubmit = false;
  }
  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);

    if (values.customerId) {
      this.setState({ customerId: values.customerId });
      this.postAssets(this.getAssetUrl(values.customerId));
    }

    this.getCustomer(`${apiHost}/api/Customer/GetAllCustomers`);
    this.getStatus(`${apiHost}/api/Device/GetAllDeviceStatus`);
  }

  getCustomer = async (url) => {
    //Get all customer id
    this.props.setLoadingPageAction(true);

    try {
      const customerList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({ customerList: customerList.data });

      console.log("customer id", customerList.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status === "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getStatus = async (url) => {
    //Get all Status
    this.props.setLoadingPageAction(true);

    try {
      const statusList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({ statusList: statusList.data });

      console.log("status ", statusList.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status === "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  unCheckradio = () => {
    var radio = document.getElementsByClassName("inputRadio");
    for (var i in radio) {
      if (radio[i].checked) {
        radio[i].checked = false;
      }
    }
  };

  handleAssetSearch = (inputSearch) => {
    if (inputSearch === "") {
      this.setState({ filterMessageA: false });
    } else {
      this.setState({ filterMessageA: true });
    }
    this.unCheckradio();

    this.assetSearchText = inputSearch;
    this.postAssets(this.getAssetUrl(this.state.customerId));
  };

  handleAssetShowEntries = (input) => {
    this.unCheckradio();

    this.assetPageSize = input;
    this.postAssets(this.getAssetUrl(this.state.customerId));
  };

  handleAssetPagination = (page) => {
    this.unCheckradio();
    this.assetPageKey = page;
    this.postAssets(this.getAssetUrl(this.state.customerId));
  };

  setAssetQueryObject = () => {
    let data = {};
    data.SearchString = this.assetSearchText;
    data.PageSize = this.assetPageSize;
    data.PageNumber = this.assetPageKey;
    return data;
  };

  getAssetUrl = (customerId) => {
    let query = {
      SearchString: this.assetSearchText,
      PageSize: this.assetPageSize,
      PageNumber: this.assetPageKey,
    }

    return `${apiHost}/api/Device/AssetsByCustomerIdForDevice/${customerId}?${encodeQueryData(query)}`
  };

  handleShowAssetsResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryA: JSON.parse(response.headers.pagination).totalItems,
    });

    if (!this.state.totalFilterA) {
      this.setState({
        totalEntryFilterA: JSON.parse(response.headers.pagination).totalItems,
        totalFilterA: true,
      });
    }

    this.setState({
      entryStartA: (parseInt(this.assetPageKey) - 1) * parseInt(this.assetPageSize) + 1,
    });

    if (JSON.parse(response.headers.pagination).totalItems < parseInt(this.state.entryEndA)) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value = parseInt(JSON.parse(response.headers.pagination).currentPage) * parseInt(this.assetPageSize);
      this.setState({
        entryEndA: value,
      });
    }

    if (this.state.entryEndA > parseInt(JSON.parse(response.headers.pagination).totalItems)) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems,
      });
    }

    if (!this.state.assetsList) {
      this.setState({
        entryStartA: "0",
        entryEndA: "0",
        totalEntryA: "0",
      });
    }
  };

  postAssets = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      const assetsList = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        assetsList: assetsList.data,
        assetsPageCount: JSON.parse(assetsList.headers.pagination).totalPages,
      });

      console.log("assetsList ", assetsList.data);

      var radio = document.getElementsByClassName("inputRadio");
      for (var i in radio) {
        if (radio[i].value === this.state.assetId) {
          radio[i].checked = true;
        }
      }

      this.handleShowAssetsResults(assetsList);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status === "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleCustomeridChange(e) {
    console.log("e.target.value", e.target.value);

    if (e.target.value === "default") {
      this.setState({
        entryStartA: "0",
        entryEndA: "0",
        totalEntryA: "0",
        totalEntryFilterA: "0",
      });
    }

    if (e.target.value === "default") {
      this.setState({
        customerID_error: true,
        assetId: "",
        assetName: "",
      });
    } else {
      this.setState({ customerID_error: false });
    }

    this.setState({ customerId: e.target.value });

    if (e.target.value !== "default") {
      this.unCheckradio();
      this.postAssets(this.getAssetUrl(e.target.value));
    }
  }

  handleNameChange(e) {
    console.log("e.target.value", e.target.value);

    if (!e.target.value) {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }

    this.setState({ name: e.target.value });
  }

  handleImeiChange = (e) => {
    console.log("imei value", e.target.value);

    if (!e.target.value) {
      this.setState({ imei_error: true });
    } else {
      this.setState({ imei_error: false });
    }

    this.setState({ imei: e.target.value });
  };

  handleSimChange = (e) => {
    console.log("sim change", e.target.value);
    this.setState({ sim: e.target.value });
  };

  handleTypeChange = (e) => {
    console.log("Type change", e.target.value);
    this.setState({ type: e.target.value });
  };

  handleTagChange = (e) => {
    console.log("Type change", e.target.value);
    this.setState({ tag: e.target.value });
  };

  handleNetworkTypeChange = (e) => {
    console.log("Network change", e.target.value);
    this.setState({ networkType: e.target.value });
  };

  handleFirmwareChange = (e) => {
    console.log("Firmware change", e.target.value);
    this.setState({ firmware: e.target.value });
  };

  handleAssetSelction = (e, name) => {
    console.log(e.target);
    console.log(name);

    this.setState({
      assetId: e.target.value,
      assetName: name,
    });
  };

  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }

  handleStatusChange(e) {
    this.setState({ status: e.target.value });
    console.log(e.target.value);
  }

  async handleSubmit() {
    this.formSubmit = true;

    if (this.state.customerId === "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }

    if (!this.state.name) {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Device/DeviceRegister`,
          {
            Imei: this.state.imei,
            Name: this.state.name,
            Description: this.state.description,
            SimNumber: this.state.sim,
            Type: this.state.type,
            Tag: this.state.tag,
            NetworkType: this.state.networkType,
            FwVersion: this.state.firmware,
            CustomerId: this.state.customerId,
            AssetId: this.state.assetId,
            DeviceStatusName: this.state.status,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        this.props.history.goBack();

        console.log("customer id", response.data);

        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status === "401") {
          this.props.history.push("/login");
        } else {

          this.props.setLoadingPageAction(false);
          if (e.response.data.statusCode === "8") {
            this.props.setErrorMessageAction("IMEI Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }
  render() {
    const arr = [10, 25, 50, 100];
    const values = queryString.parse(this.props.location.search);
    var selectCustomerTag;

    if (values.customerId) {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
          value={values.customerId}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    } else {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    }

    return (
      <div>
        <Layout>
          <Helmet>
            <title>Create Device </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Create Device</h2>
              <h6>Device</h6>
              <hr></hr>
              <Form>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">IMEI</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleImeiChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.imei_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The IMEI field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Name</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleNameChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.name_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Description</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      onChange={this.handleDescriptionChange.bind(this)}
                      rows="3"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">SIM</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleSimChange.bind(this)}
                    />
                    {/* <p
                    style={
                      this.state.name_error
                      ? { color: "#a94442", fontSize: "14px" }
                      : { display: "none" }
                    }
                    >
                    The Sim field is required.
                  </p> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Type/Model</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      value={this.state.type}
                      onChange={this.handleTypeChange.bind(this)}
                    />
                    {/* <p
                    style={
                      this.state.name_error
                      ? { color: "#a94442", fontSize: "14px" }
                      : { display: "none" }
                    }
                    >
                    The Type/Model field is required.
                  </p> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Tag</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleTagChange.bind(this)}
                    />
                    {/* <p
                    style={
                      this.state.name_error
                      ? { color: "#a94442", fontSize: "14px" }
                        : { display: "none" }
                      }
                      >
                      The Tag field is required.
                    </p> */}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Network</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      value={this.state.networkType}
                      onChange={this.handleNetworkTypeChange.bind(this)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Firmware</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleFirmwareChange.bind(this)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Customer</span>
                  </Form.Label>
                  <Col sm={10}>
                    {selectCustomerTag}
                    <p
                      style={
                        this.state.customerID_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Asset</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Label column sm={10}>
                      <span className="inline-left-input">
                        {" "}
                        {!this.state.assetName ? "UNASSIGNED" : this.state.assetName}
                      </span>
                    </Form.Label>
                    <br />
                    <div className="inline">
                      <ShowEntries
                        showEntriesCallback={this.handleAssetShowEntries}
                        data={arr}
                      />
                      <Search searchCallback={this.handleAssetSearch} />
                    </div>
                    <Table striped responsive>
                      <thead>
                        <tr>
                          <th></th>
                          <th>Name</th>
                          <th>Tag1</th>
                          <th>Tag2</th>
                          <th>Status</th>
                          <th>Updated</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.assetsList.length === 0 || this.state.customerId === "default" ? (
                          <tr>
                            <td style={{ textAlign: "center" }} colSpan="6">
                              Nothing to show
                            </td>{" "}
                          </tr>
                        ) : (
                          this.state.assetsList.map((item, index) => {
                            return (
                              <tr>
                                <td>
                                  <input
                                    value={item.id}
                                    id={item.id}
                                    className="inputRadio"
                                    onChange={(e) => {
                                      this.handleAssetSelction(e, item.name);
                                    }}
                                    name="assetselection"
                                    type="radio"
                                  />
                                </td>
                                <td>{item.name}</td>
                                <td>{item.tag1}</td>
                                <td>{item.tag2}</td>
                                <td>{item.status}</td>
                                <td>{item.dbUpdated}</td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </Table>
                    <div className="paginationDetails">
                      <ShowingResults
                        currentEntryStart={this.state.entryStartA}
                        currentEntryEnd={this.state.entryEndA}
                        totalEntries={this.state.totalEntryA}
                        totalFilterEntries={this.state.totalEntryFilterA}
                        filterMessage={this.state.filterMessageA}
                      />
                      <Paginations
                        onPagination={this.handleAssetsPagination}
                        pageCount={this.state.assetsPageCount}
                        pageRange={5}
                      ></Paginations>
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Status</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="select"
                      value={this.state.status}
                      onChange={this.handleStatusChange.bind(this)}
                    >
                      {this.state.statusList.map((item, index) => {
                        return <option value={item.name}>{item.name}</option>;
                      })}
                    </Form.Control>
                  </Col>
                </Form.Group>
                <div className="footer-menu">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => {
                      // this.props.history.push("/devices");
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Create
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDevice);
